const getPageImage = (pages, domain) => pages.filter((page) => page.domain === domain);

export default getPageImage;
